module.exports = __webpack_public_path__ + "static/media/notify.e75eaceb.svg";